import clsx from 'clsx';
import React, { memo, PropsWithChildren } from 'react';

type AppPaperBoxProps = PropsWithChildren & {
  className?: string;
  onClick?: () => void;
};

const AppPaperBox = ({ children, className, onClick }: AppPaperBoxProps) => {
  return (
    <div
      className={clsx(
        'rounded-2xl bg-white dark:bg-[--table-heading-color]',
        className
      )}
      style={{
        boxShadow: 'var(--wrapper-shadow)',
      }}
      onClick={onClick}
    >
      {children}
    </div>
  );
};

export default memo(AppPaperBox);
